var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowDiagonal = function SvgArrowDiagonal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.00001C6 4.37334 6.3 4.66668 6.66667 4.66668H10.3933L3.13333 11.9267C2.87333 12.1867 2.87333 12.6067 3.13333 12.8667C3.39333 13.1267 3.81333 13.1267 4.07333 12.8667L11.3333 5.60668V9.33334C11.3333 9.70001 11.6333 10 12 10C12.3667 10 12.6667 9.70001 12.6667 9.33334V4.00001C12.6667 3.63334 12.3667 3.33334 12 3.33334H6.66667C6.3 3.33334 6 3.63334 6 4.00001Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDiagonal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-diagonal.7437f38b73ffb943fdbd9515539fb71b.svg";